// ═══════════════════════════════════════════════════════
// trackSession.js — logs an app-open session with platform + location.
// Location chain: GPS (if permitted) → IP-based → saved city. Fire-and-forget.
// ═══════════════════════════════════════════════════════
import { supabase } from './supabase'
import { Capacitor } from '@capacitor/core'

async function getGpsArea() {
  try {
    const { Geolocation } = await import('@capacitor/geolocation')
    const pos = await Geolocation.getCurrentPosition({ timeout: 5000, enableHighAccuracy: false })
    const { latitude, longitude } = pos.coords
    // reverse-geocode to a human area via Nominatim
    const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=14`)
    const data = await res.json()
    const a = data.address || {}
    const area = a.suburb || a.neighbourhood || a.village || a.town || a.city_district || ''
    const city = a.city || a.town || a.county || ''
    const label = [area, city].filter(Boolean).join(', ')
    return label ? `${label} (GPS)` : null
  } catch { return null }
}

async function getIpCity() {
  try {
    const res = await fetch('https://ipapi.co/json/')
    const data = await res.json()
    const parts = [data.city, data.region].filter(Boolean)
    return parts.length ? `${parts.join(', ')} (IP)` : null
  } catch { return null }
}

function getSavedCity(userId) {
  try {
    const c = localStorage.getItem('syninn_selected_city_' + userId) || localStorage.getItem('syninn_selected_city')
    return c ? `${c} (saved)` : null
  } catch { return null }
}

export async function trackSession(userId) {
  if (!userId) return
  try {
    const platform = Capacitor.getPlatform() // 'android' | 'ios' | 'web'
    // location chain: GPS → IP → saved city
    let location = null
    if (Capacitor.isNativePlatform()) location = await getGpsArea()
    if (!location) location = await getIpCity()
    if (!location) location = getSavedCity(userId)
    await supabase.from('app_sessions').insert({ user_id: userId, platform, location: location || null })
  } catch { /* never block the app */ }
}